import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/alhussaini/banner_img.webp";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Banner() {
  return (
    <section
      className="alhussaini_banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="baner_img">
              <StaticImage
                src="../../../images/case-studies/alhussaini/logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={255}
                height={62}
              />
            </div>
            <h1 className="h2">Al Hussain Trading Company</h1>
            <p>
              Al Hussain Trading Company is a leading marketplace in Saudi
              Arabia for watches and jewelry, along with an expanded portfolio
              that includes leather goods, and writing instruments. Built on
              delivering an unprecedented experience to customers based on
              integrity and innovation, the platform includes renowned brands as
              well.
            </p>
            <Link
              to="https://alhussainitrading.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit Website
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
